export default "/WebApp/dist/assets/fonts/ui-grid.ttf";